import { East } from '@mui/icons-material';

import { AiThreadResponseQl } from '../../../../../../../../../../data/smart-search/hooks';
import { getTextForQuantity } from '../../../../../../../../../../dtos/own/helpers';
import { useTranslate } from '../../../../../../../../../../hooks/useTranslate';
import { useMarket } from '../../../../../../../../../../providers/MarketProvider';
import { Button } from '../../../../../../../../../Button/Button';
import { ExternalLink } from '../../../../../../../../../ExternalLink/ExternalLink';
import {
  createDestinations,
  getUrlWithJsonRecipe,
  getValidSelectedDay,
} from '../../../../../../Amelia.utils';
import { ButtonWrapper, Explainer } from '../../Message.styles';
import {
  InspirationalMessage,
  Li,
  StyledDestination,
  StyledDestinationName,
  StyledDestinationNights,
  Ul,
} from './Itinerary.styles';

type Props = {
  content: AiThreadResponseQl;
  onViewTripClicked: () => void;
};

export const Itinerary = ({ content, onViewTripClicked }: Props) => {
  const { t } = useTranslate();
  const market = useMarket();
  const destinations = createDestinations(content);
  const selectedDay = getValidSelectedDay(content?.selectedDay);

  return (
    <>
      <InspirationalMessage>
        {content.additionalTexts?.inspirationalMessage}
      </InspirationalMessage>

      {destinations.map(({ name, activities, numberOfNights }) => (
        <StyledDestination key={name}>
          <StyledDestinationName>
            {name}
            <StyledDestinationNights>{` (${getTextForQuantity(
              numberOfNights ?? 0,
              {
                single: t('night.single'),
                plural: t('night.plural'),
              }
            )})`}</StyledDestinationNights>
          </StyledDestinationName>
          <Ul>
            {activities.map((activity) => (
              <Li key={activity}>{activity}</Li>
            ))}
          </Ul>
        </StyledDestination>
      ))}

      <ButtonWrapper>
        <Button asChild variant="important" onClick={onViewTripClicked}>
          <ExternalLink
            href={getUrlWithJsonRecipe(
              market,
              content.recipeJson as string,
              content?.additionalTexts?.id,
              selectedDay
            )}
          >
            {t('explore.amelia.viewTripButton')}

            <East />
          </ExternalLink>
        </Button>
      </ButtonWrapper>

      <Explainer>{t('explore.amelia.explainer')}</Explainer>
    </>
  );
};
